import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useT } from '../i18n/useT';

export default function NotFoundPage() {
  const t = useT();
  const n = t.notFound;

  return (
    <>
      <Helmet>
        <title>404 – Docudi</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="not-found">
        <div className="container text-center">
          <div className="not-found__code">404</div>
          <h1 className="not-found__title">{n.title}</h1>
          <p className="not-found__desc">{n.desc}</p>
          <div className="not-found__actions">
            <Link to="/" className="btn btn-primary">{n.home}</Link>
            <Link to="/support" className="btn btn-secondary">{n.help}</Link>
          </div>
        </div>
      </div>
    </>
  );
}
